import { n as e } from "./rolldown-runtime-CWhphoD1.js";
import { t } from "./utils-DiFe-_ei.js";
import { Button as n, buttonVariants as r } from "./foundations/button.js";
import "./button-C8zrAH2m.js";
import { t as i } from "./chevron-down-D8vOGVnQ.js";
import { t as a } from "./chevron-left-ObWP-3BV.js";
import { t as o } from "./chevron-right-C4-3WHKK.js";
import * as s from "react";
import c, { createContext as l, useCallback as u, useContext as d, useEffect as f, useLayoutEffect as p, useMemo as m, useRef as h, useState as g } from "react";
import { jsx as _ } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@date-fns+tz@1.5.0/node_modules/@date-fns/tz/tzName/index.js
function v(e, t, n = "long") {
	return new Intl.DateTimeFormat("en-US", {
		hour: "numeric",
		timeZone: e,
		timeZoneName: n
	}).format(t).split(/\s/g).slice(2).join(" ");
}
//#endregion
//#region ../../node_modules/.pnpm/@date-fns+tz@1.5.0/node_modules/@date-fns/tz/tzOffset/index.js
var y = {}, b = {};
function x(e, t) {
	try {
		let n = (y[e] ||= new Intl.DateTimeFormat("en-US", {
			timeZone: e,
			timeZoneName: "longOffset"
		}).format)(t).split("GMT")[1];
		return n in b ? b[n] : C(n, n.split(":"));
	} catch {
		if (e in b) return b[e];
		let t = e?.match(S);
		return t ? C(e, t.slice(1)) : NaN;
	}
}
var S = /([+-]\d\d):?(\d\d)?/;
function C(e, t) {
	let n = +(t[0] || 0), r = +(t[1] || 0), i = (t[2] || 0) / 60;
	return b[e] = n * 60 + r > 0 ? n * 60 + r + i : n * 60 - r - i;
}
//#endregion
//#region ../../node_modules/.pnpm/@date-fns+tz@1.5.0/node_modules/@date-fns/tz/date/mini.js
var w = class e extends Date {
	constructor(...e) {
		super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(x(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), te(this, e)) : this.setTime(Date.now());
	}
	static tz(t, ...n) {
		return n.length ? new e(...n, t) : new e(Date.now(), t);
	}
	withTimeZone(t) {
		return new e(+this, t);
	}
	getTimezoneOffset() {
		let e = -x(this.timeZone, this);
		return e > 0 ? Math.floor(e) : Math.ceil(e);
	}
	setTime(e) {
		return Date.prototype.setTime.apply(this, arguments), E(this), +this;
	}
	[Symbol.for("constructDateFrom")](t) {
		return new e(+new Date(t), this.timeZone);
	}
}, T = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
	if (!T.test(e)) return;
	let t = e.replace(T, "$1UTC");
	w.prototype[t] && (e.startsWith("get") ? w.prototype[e] = function() {
		return this.internal[t]();
	} : (w.prototype[e] = function() {
		return Date.prototype[t].apply(this.internal, arguments), ee(this), +this;
	}, w.prototype[t] = function() {
		return Date.prototype[t].apply(this, arguments), E(this), +this;
	}));
});
function E(e) {
	e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-x(e.timeZone, e) * 60));
}
function ee(e) {
	Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), te(e);
}
function te(e, t) {
	let n = Array.isArray(t) ? ne(t) : +e.internal, r = x(e.timeZone, e), i = r > 0 ? Math.floor(r) : Math.ceil(r), a = /* @__PURE__ */ new Date(+e);
	a.setUTCHours(a.getUTCHours() - 1);
	let o = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), s = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), c = o - s, l = o;
	if (c && o !== i && Date.prototype.getHours.apply(e) !== (Array.isArray(t) ? t[3] || 0 : e.internal.getUTCHours())) {
		let t = /* @__PURE__ */ new Date(+e), n = o - i;
		n && t.setUTCMinutes(t.getUTCMinutes() + n);
		let r = x(e.timeZone, t);
		(r > 0 ? Math.floor(r) : Math.ceil(r)) === i && (l = s);
	}
	let u = l - i;
	u && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + u);
	let d = /* @__PURE__ */ new Date(+e);
	d.setUTCSeconds(0);
	let f = o > 0 ? d.getSeconds() : (d.getSeconds() - 60) % 60, p = Math.round(-(x(e.timeZone, e) * 60)) % 60;
	(p || f) && Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + p + f);
	let m = x(e.timeZone, e), h = m > 0 ? Math.floor(m) : Math.ceil(m), g = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - h, _ = h !== i, v = g - u, y = h - i, b = n - h * 60 * 1e3, S = y > 0 && re(e) - n === y * 60 * 1e3 && re(e, b) !== n;
	if (_ && v && !S) {
		Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + v);
		let t = x(e.timeZone, e), n = h - (t > 0 ? Math.floor(t) : Math.ceil(t));
		n && v < 0 && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + n);
	}
	E(e);
	let C = (t ? n : n + p * 1e3) - +e.internal;
	C && Math.abs(C) < 1800 * 1e3 && (Date.prototype.setTime.call(e, +e + C), E(e));
}
function ne(e) {
	return Date.UTC(e[0], e.length > 1 ? e[1] : 0, e.length > 2 ? e[2] : 1, ...e.slice(3));
}
function re(e, t) {
	let n = new Date(t ?? +e);
	return n.setUTCSeconds(n.getUTCSeconds() - Math.round(-x(e.timeZone, n) * 60)), +n;
}
//#endregion
//#region ../../node_modules/.pnpm/@date-fns+tz@1.5.0/node_modules/@date-fns/tz/date/index.js
var D = class e extends w {
	static tz(t, ...n) {
		return n.length ? new e(...n, t) : new e(Date.now(), t);
	}
	toISOString() {
		let [e, t, n] = this.tzComponents(), r = `${e}${t}:${n}`;
		return this.internal.toISOString().slice(0, -1) + r;
	}
	toString() {
		return `${this.toDateString()} ${this.toTimeString()}`;
	}
	toDateString() {
		let [e, t, n, r] = this.internal.toUTCString().split(" ");
		return `${e?.slice(0, -1)} ${n} ${t} ${r}`;
	}
	toTimeString() {
		let e = this.internal.toUTCString().split(" ")[4], [t, n, r] = this.tzComponents();
		return `${e} GMT${t}${n}${r} (${v(this.timeZone, this)})`;
	}
	toLocaleString(e, t) {
		return Date.prototype.toLocaleString.call(this, e, {
			...t,
			timeZone: t?.timeZone || this.timeZone
		});
	}
	toLocaleDateString(e, t) {
		return Date.prototype.toLocaleDateString.call(this, e, {
			...t,
			timeZone: t?.timeZone || this.timeZone
		});
	}
	toLocaleTimeString(e, t) {
		return Date.prototype.toLocaleTimeString.call(this, e, {
			...t,
			timeZone: t?.timeZone || this.timeZone
		});
	}
	tzComponents() {
		let e = this.getTimezoneOffset();
		return [
			e > 0 ? "-" : "+",
			String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"),
			String(Math.abs(e) % 60).padStart(2, "0")
		];
	}
	withTimeZone(t) {
		return new e(+this, t);
	}
	[Symbol.for("constructDateFrom")](t) {
		return new e(+new Date(t), this.timeZone);
	}
}, ie = 365.2425, ae = 6048e5, oe = 864e5, se = 6e4, ce = 36e5, le = 3600 * 24;
le * 7, le * ie / 12 * 3;
var ue = Symbol.for("constructDateFrom");
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/constructFrom.js
function O(e, t) {
	return typeof e == "function" ? e(t) : e && typeof e == "object" && ue in e ? e[ue](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/toDate.js
function k(e, t) {
	return O(t || e, e);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/addDays.js
function A(e, t, n) {
	let r = k(e, n?.in);
	return isNaN(t) ? O(n?.in || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/addMonths.js
function de(e, t, n) {
	let r = k(e, n?.in);
	if (isNaN(t)) return O(n?.in || e, NaN);
	if (!t) return r;
	let i = r.getDate(), a = O(n?.in || e, r.getTime());
	return a.setMonth(r.getMonth() + t + 1, 0), i >= a.getDate() ? a : (r.setFullYear(a.getFullYear(), a.getMonth(), i), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/defaultOptions.js
var fe = {};
function j() {
	return fe;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfWeek.js
function M(e, t) {
	let n = j(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = k(e, t?.in), a = i.getDay(), o = (a < r ? 7 : 0) + a - r;
	return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfISOWeek.js
function N(e, t) {
	return M(e, {
		...t,
		weekStartsOn: 1
	});
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getISOWeekYear.js
function pe(e, t) {
	let n = k(e, t?.in), r = n.getFullYear(), i = O(n, 0);
	i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
	let a = N(i), o = O(n, 0);
	o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
	let s = N(o);
	return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.js
function me(e) {
	let t = k(e), n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
	return n.setUTCFullYear(t.getFullYear()), e - +n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/normalizeDates.js
function P(e, ...t) {
	let n = O.bind(null, e || t.find((e) => typeof e == "object"));
	return t.map(n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfDay.js
function F(e, t) {
	let n = k(e, t?.in);
	return n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/differenceInCalendarDays.js
function he(e, t, n) {
	let [r, i] = P(n?.in, e, t), a = F(r), o = F(i), s = +a - me(a), c = +o - me(o);
	return Math.round((s - c) / oe);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfISOWeekYear.js
function ge(e, t) {
	let n = pe(e, t), r = O(t?.in || e, 0);
	return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), N(r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/addWeeks.js
function _e(e, t, n) {
	return A(e, t * 7, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/addYears.js
function ve(e, t, n) {
	return de(e, t * 12, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/max.js
function ye(e, t) {
	let n, r = t?.in;
	return e.forEach((e) => {
		!r && typeof e == "object" && (r = O.bind(null, e));
		let t = k(e, r);
		(!n || n < t || isNaN(+t)) && (n = t);
	}), O(r, n || NaN);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/min.js
function be(e, t) {
	let n, r = t?.in;
	return e.forEach((e) => {
		!r && typeof e == "object" && (r = O.bind(null, e));
		let t = k(e, r);
		(!n || n > t || isNaN(+t)) && (n = t);
	}), O(r, n || NaN);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isSameDay.js
function xe(e, t, n) {
	let [r, i] = P(n?.in, e, t);
	return +F(r) == +F(i);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isDate.js
function Se(e) {
	return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isValid.js
function Ce(e) {
	return !(!Se(e) && typeof e != "number" || isNaN(+k(e)));
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/differenceInCalendarMonths.js
function we(e, t, n) {
	let [r, i] = P(n?.in, e, t), a = r.getFullYear() - i.getFullYear(), o = r.getMonth() - i.getMonth();
	return a * 12 + o;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/endOfMonth.js
function Te(e, t) {
	let n = k(e, t?.in), r = n.getMonth();
	return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/normalizeInterval.js
function Ee(e, t) {
	let [n, r] = P(e, t.start, t.end);
	return {
		start: n,
		end: r
	};
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/eachMonthOfInterval.js
function De(e, t) {
	let { start: n, end: r } = Ee(t?.in, e), i = +n > +r, a = i ? +n : +r, o = i ? r : n;
	o.setHours(0, 0, 0, 0), o.setDate(1);
	let s = t?.step ?? 1;
	if (!s) return [];
	s < 0 && (s = -s, i = !i);
	let c = [];
	for (; +o <= a;) c.push(O(n, o)), o.setMonth(o.getMonth() + s);
	return i ? c.reverse() : c;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfMonth.js
function Oe(e, t) {
	let n = k(e, t?.in);
	return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/endOfYear.js
function ke(e, t) {
	let n = k(e, t?.in), r = n.getFullYear();
	return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfYear.js
function Ae(e, t) {
	let n = k(e, t?.in);
	return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/eachYearOfInterval.js
function je(e, t) {
	let { start: n, end: r } = Ee(t?.in, e), i = +n > +r, a = i ? +n : +r, o = i ? r : n;
	o.setHours(0, 0, 0, 0), o.setMonth(0, 1);
	let s = t?.step ?? 1;
	if (!s) return [];
	s < 0 && (s = -s, i = !i);
	let c = [];
	for (; +o <= a;) c.push(O(n, o)), o.setFullYear(o.getFullYear() + s);
	return i ? c.reverse() : c;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/endOfWeek.js
function Me(e, t) {
	let n = j(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = k(e, t?.in), a = i.getDay(), o = (a < r ? -7 : 0) + 6 - (a - r);
	return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/endOfISOWeek.js
function Ne(e, t) {
	return Me(e, {
		...t,
		weekStartsOn: 1
	});
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/en-US/_lib/formatDistance.js
var Pe = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
}, Fe = (e, t, n) => {
	let r, i = Pe[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildFormatLongFn.js
function Ie(e) {
	return (t = {}) => {
		let n = t.width ? String(t.width) : e.defaultWidth;
		return e.formats[n] || e.formats[e.defaultWidth];
	};
}
var Le = {
	date: Ie({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: Ie({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: Ie({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
}, Re = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
}, ze = (e, t, n, r) => Re[e];
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildLocalizeFn.js
function I(e) {
	return (t, n) => {
		let r = n?.context ? String(n.context) : "standalone", i;
		if (r === "formatting" && e.formattingValues) {
			let t = e.defaultFormattingWidth || e.defaultWidth, r = n?.width ? String(n.width) : t;
			i = e.formattingValues[r] || e.formattingValues[t];
		} else {
			let t = e.defaultWidth, r = n?.width ? String(n.width) : e.defaultWidth;
			i = e.values[r] || e.values[t];
		}
		let a = e.argumentCallback ? e.argumentCallback(t) : t;
		return i[a];
	};
}
var Be = {
	ordinalNumber: (e, t) => {
		let n = Number(e), r = n % 100;
		if (r > 20 || r < 10) switch (r % 10) {
			case 1: return n + "st";
			case 2: return n + "nd";
			case 3: return n + "rd";
		}
		return n + "th";
	},
	era: I({
		values: {
			narrow: ["B", "A"],
			abbreviated: ["BC", "AD"],
			wide: ["Before Christ", "Anno Domini"]
		},
		defaultWidth: "wide"
	}),
	quarter: I({
		values: {
			narrow: [
				"1",
				"2",
				"3",
				"4"
			],
			abbreviated: [
				"Q1",
				"Q2",
				"Q3",
				"Q4"
			],
			wide: [
				"1st quarter",
				"2nd quarter",
				"3rd quarter",
				"4th quarter"
			]
		},
		defaultWidth: "wide",
		argumentCallback: (e) => e - 1
	}),
	month: I({
		values: {
			narrow: [
				"J",
				"F",
				"M",
				"A",
				"M",
				"J",
				"J",
				"A",
				"S",
				"O",
				"N",
				"D"
			],
			abbreviated: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],
			wide: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		defaultWidth: "wide"
	}),
	day: I({
		values: {
			narrow: [
				"S",
				"M",
				"T",
				"W",
				"T",
				"F",
				"S"
			],
			short: [
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			],
			abbreviated: [
				"Sun",
				"Mon",
				"Tue",
				"Wed",
				"Thu",
				"Fri",
				"Sat"
			],
			wide: [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		},
		defaultWidth: "wide"
	}),
	dayPeriod: I({
		values: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			}
		},
		defaultWidth: "wide",
		formattingValues: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			}
		},
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildMatchFn.js
function L(e) {
	return (t, n = {}) => {
		let r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
		if (!a) return null;
		let o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? He(s, (e) => e.test(o)) : Ve(s, (e) => e.test(o)), l;
		l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
		let u = t.slice(o.length);
		return {
			value: l,
			rest: u
		};
	};
}
function Ve(e, t) {
	for (let n in e) if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n])) return n;
}
function He(e, t) {
	for (let n = 0; n < e.length; n++) if (t(e[n])) return n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/_lib/buildMatchPatternFn.js
function Ue(e) {
	return (t, n = {}) => {
		let r = t.match(e.matchPattern);
		if (!r) return null;
		let i = r[0], a = t.match(e.parsePattern);
		if (!a) return null;
		let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
		o = n.valueCallback ? n.valueCallback(o) : o;
		let s = t.slice(i.length);
		return {
			value: o,
			rest: s
		};
	};
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/locale/en-US.js
var R = {
	code: "en-US",
	formatDistance: Fe,
	formatLong: Le,
	formatRelative: ze,
	localize: Be,
	match: {
		ordinalNumber: Ue({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: (e) => parseInt(e, 10)
		}),
		era: L({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: L({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (e) => e + 1
		}),
		month: L({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: L({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: L({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getDayOfYear.js
function We(e, t) {
	let n = k(e, t?.in);
	return he(n, Ae(n)) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getISOWeek.js
function Ge(e, t) {
	let n = k(e, t?.in), r = N(n) - +ge(n);
	return Math.round(r / ae) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getWeekYear.js
function Ke(e, t) {
	let n = k(e, t?.in), r = n.getFullYear(), i = j(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = O(t?.in || e, 0);
	o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
	let s = M(o, t), c = O(t?.in || e, 0);
	c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
	let l = M(c, t);
	return +n >= +s ? r + 1 : +n >= +l ? r : r - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/startOfWeekYear.js
function qe(e, t) {
	let n = j(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = Ke(e, t), a = O(t?.in || e, 0);
	return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), M(a, t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getWeek.js
function Je(e, t) {
	let n = k(e, t?.in), r = M(n, t) - +qe(n, t);
	return Math.round(r / ae) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/addLeadingZeros.js
function z(e, t) {
	return (e < 0 ? "-" : "") + Math.abs(e).toString().padStart(t, "0");
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/format/lightFormatters.js
var B = {
	y(e, t) {
		let n = e.getFullYear(), r = n > 0 ? n : 1 - n;
		return z(t === "yy" ? r % 100 : r, t.length);
	},
	M(e, t) {
		let n = e.getMonth();
		return t === "M" ? String(n + 1) : z(n + 1, 2);
	},
	d(e, t) {
		return z(e.getDate(), t.length);
	},
	a(e, t) {
		let n = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.toUpperCase();
			case "aaa": return n;
			case "aaaaa": return n[0];
			default: return n === "am" ? "a.m." : "p.m.";
		}
	},
	h(e, t) {
		return z(e.getHours() % 12 || 12, t.length);
	},
	H(e, t) {
		return z(e.getHours(), t.length);
	},
	m(e, t) {
		return z(e.getMinutes(), t.length);
	},
	s(e, t) {
		return z(e.getSeconds(), t.length);
	},
	S(e, t) {
		let n = t.length, r = e.getMilliseconds();
		return z(Math.trunc(r * 10 ** (n - 3)), t.length);
	}
}, V = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
}, Ye = {
	G: function(e, t, n) {
		let r = +(e.getFullYear() > 0);
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(r, { width: "abbreviated" });
			case "GGGGG": return n.era(r, { width: "narrow" });
			default: return n.era(r, { width: "wide" });
		}
	},
	y: function(e, t, n) {
		if (t === "yo") {
			let t = e.getFullYear(), r = t > 0 ? t : 1 - t;
			return n.ordinalNumber(r, { unit: "year" });
		}
		return B.y(e, t);
	},
	Y: function(e, t, n, r) {
		let i = Ke(e, r), a = i > 0 ? i : 1 - i;
		return t === "YY" ? z(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : z(a, t.length);
	},
	R: function(e, t) {
		return z(pe(e), t.length);
	},
	u: function(e, t) {
		return z(e.getFullYear(), t.length);
	},
	Q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "Q": return String(r);
			case "QQ": return z(r, 2);
			case "Qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "QQQ": return n.quarter(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "q": return String(r);
			case "qq": return z(r, 2);
			case "qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "qqq": return n.quarter(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "M":
			case "MM": return B.M(e, t);
			case "Mo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "MMM": return n.month(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return n.month(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "L": return String(r + 1);
			case "LL": return z(r + 1, 2);
			case "Lo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "LLL": return n.month(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return n.month(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function(e, t, n, r) {
		let i = Je(e, r);
		return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : z(i, t.length);
	},
	I: function(e, t, n) {
		let r = Ge(e);
		return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : z(r, t.length);
	},
	d: function(e, t, n) {
		return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : B.d(e, t);
	},
	D: function(e, t, n) {
		let r = We(e);
		return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : z(r, t.length);
	},
	E: function(e, t, n) {
		let r = e.getDay();
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "e": return String(a);
			case "ee": return z(a, 2);
			case "eo": return n.ordinalNumber(a, { unit: "day" });
			case "eee": return n.day(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return n.day(i, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(i, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "c": return String(a);
			case "cc": return z(a, t.length);
			case "co": return n.ordinalNumber(a, { unit: "day" });
			case "ccc": return n.day(i, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return n.day(i, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(i, {
				width: "short",
				context: "standalone"
			});
			default: return n.day(i, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function(e, t, n) {
		let r = e.getDay(), i = r === 0 ? 7 : r;
		switch (t) {
			case "i": return String(i);
			case "ii": return z(i, t.length);
			case "io": return n.ordinalNumber(i, { unit: "day" });
			case "iii": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function(e, t, n) {
		let r = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return n.dayPeriod(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r === 12 ? V.noon : r === 0 ? V.midnight : r / 12 >= 1 ? "pm" : "am", t) {
			case "b":
			case "bb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r >= 17 ? V.evening : r >= 12 ? V.afternoon : r >= 4 ? V.morning : V.night, t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function(e, t, n) {
		if (t === "ho") {
			let t = e.getHours() % 12;
			return t === 0 && (t = 12), n.ordinalNumber(t, { unit: "hour" });
		}
		return B.h(e, t);
	},
	H: function(e, t, n) {
		return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : B.H(e, t);
	},
	K: function(e, t, n) {
		let r = e.getHours() % 12;
		return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : z(r, t.length);
	},
	k: function(e, t, n) {
		let r = e.getHours();
		return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : z(r, t.length);
	},
	m: function(e, t, n) {
		return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : B.m(e, t);
	},
	s: function(e, t, n) {
		return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : B.s(e, t);
	},
	S: function(e, t) {
		return B.S(e, t);
	},
	X: function(e, t, n) {
		let r = e.getTimezoneOffset();
		if (r === 0) return "Z";
		switch (t) {
			case "X": return Ze(r);
			case "XXXX":
			case "XX": return H(r);
			default: return H(r, ":");
		}
	},
	x: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "x": return Ze(r);
			case "xxxx":
			case "xx": return H(r);
			default: return H(r, ":");
		}
	},
	O: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + Xe(r, ":");
			default: return "GMT" + H(r, ":");
		}
	},
	z: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + Xe(r, ":");
			default: return "GMT" + H(r, ":");
		}
	},
	t: function(e, t, n) {
		return z(Math.trunc(e / 1e3), t.length);
	},
	T: function(e, t, n) {
		return z(+e, t.length);
	}
};
function Xe(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
	return a === 0 ? n + String(i) : n + String(i) + t + z(a, 2);
}
function Ze(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + z(Math.abs(e) / 60, 2) : H(e, t);
}
function H(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = z(Math.trunc(r / 60), 2), a = z(r % 60, 2);
	return n + i + t + a;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/_lib/format/longFormatters.js
var Qe = (e, t) => {
	switch (e) {
		case "P": return t.date({ width: "short" });
		case "PP": return t.date({ width: "medium" });
		case "PPP": return t.date({ width: "long" });
		default: return t.date({ width: "full" });
	}
}, $e = (e, t) => {
	switch (e) {
		case "p": return t.time({ width: "short" });
		case "pp": return t.time({ width: "medium" });
		case "ppp": return t.time({ width: "long" });
		default: return t.time({ width: "full" });
	}
}, et = {
	p: $e,
	P: (e, t) => {
		let n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
		if (!i) return Qe(e, t);
		let a;
		switch (r) {
			case "P":
				a = t.dateTime({ width: "short" });
				break;
			case "PP":
				a = t.dateTime({ width: "medium" });
				break;
			case "PPP":
				a = t.dateTime({ width: "long" });
				break;
			default:
				a = t.dateTime({ width: "full" });
				break;
		}
		return a.replace("{{date}}", Qe(r, t)).replace("{{time}}", $e(i, t));
	}
}, tt = /^D+$/, nt = /^Y+$/, rt = [
	"D",
	"DD",
	"YY",
	"YYYY"
];
function it(e) {
	return tt.test(e);
}
function at(e) {
	return nt.test(e);
}
function ot(e, t, n) {
	let r = st(e, t, n);
	if (console.warn(r), rt.includes(e)) throw RangeError(r);
}
function st(e, t, n) {
	let r = e[0] === "Y" ? "years" : "days of the month";
	return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/format.js
var ct = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, lt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ut = /^'([^]*?)'?$/, dt = /''/g, ft = /[a-zA-Z]/;
function pt(e, t, n) {
	let r = j(), i = n?.locale ?? r.locale ?? R, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = k(e, n?.in);
	if (!Ce(s)) throw RangeError("Invalid time value");
	let c = t.match(lt).map((e) => {
		let t = e[0];
		if (t === "p" || t === "P") {
			let n = et[t];
			return n(e, i.formatLong);
		}
		return e;
	}).join("").match(ct).map((e) => {
		if (e === "''") return {
			isToken: !1,
			value: "'"
		};
		let t = e[0];
		if (t === "'") return {
			isToken: !1,
			value: mt(e)
		};
		if (Ye[t]) return {
			isToken: !0,
			value: e
		};
		if (t.match(ft)) throw RangeError("Format string contains an unescaped latin alphabet character `" + t + "`");
		return {
			isToken: !1,
			value: e
		};
	});
	i.localize.preprocessor && (c = i.localize.preprocessor(s, c));
	let l = {
		firstWeekContainsDate: a,
		weekStartsOn: o,
		locale: i
	};
	return c.map((r) => {
		if (!r.isToken) return r.value;
		let a = r.value;
		(!n?.useAdditionalWeekYearTokens && at(a) || !n?.useAdditionalDayOfYearTokens && it(a)) && ot(a, t, String(e));
		let o = Ye[a[0]];
		return o(s, a, i.localize, l);
	}).join("");
}
function mt(e) {
	let t = e.match(ut);
	return t ? t[1].replace(dt, "'") : e;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getDaysInMonth.js
function ht(e, t) {
	let n = k(e, t?.in), r = n.getFullYear(), i = n.getMonth(), a = O(n, 0);
	return a.setFullYear(r, i + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getMonth.js
function gt(e, t) {
	return k(e, t?.in).getMonth();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/getYear.js
function _t(e, t) {
	return k(e, t?.in).getFullYear();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isAfter.js
function vt(e, t) {
	return +k(e) > +k(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isBefore.js
function yt(e, t) {
	return +k(e) < +k(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isSameMonth.js
function bt(e, t, n) {
	let [r, i] = P(n?.in, e, t);
	return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/isSameYear.js
function xt(e, t, n) {
	let [r, i] = P(n?.in, e, t);
	return r.getFullYear() === i.getFullYear();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/setMonth.js
function St(e, t, n) {
	let r = k(e, n?.in), i = r.getFullYear(), a = r.getDate(), o = O(n?.in || e, 0);
	o.setFullYear(i, t, 15), o.setHours(0, 0, 0, 0);
	let s = ht(o);
	return r.setMonth(t, Math.min(a, s)), r;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.4.0/node_modules/date-fns/setYear.js
function Ct(e, t, n) {
	let r = k(e, n?.in);
	return isNaN(+r) ? O(n?.in || e, NaN) : (r.setFullYear(t), r);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getBroadcastWeeksInMonth.js
var wt = 5, Tt = 4;
function Et(e, t) {
	let n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, i = t.addDays(e, -r + 1), a = t.addDays(i, wt * 7 - 1);
	return t.getMonth(e) === t.getMonth(a) ? wt : Tt;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/startOfBroadcastWeek.js
function Dt(e, t) {
	let n = t.startOfMonth(e), r = n.getDay();
	return r === 1 ? n : r === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (r - 1));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/endOfBroadcastWeek.js
function Ot(e, t) {
	let n = Dt(e, t), r = Et(e, t);
	return t.addDays(n, r * 7 - 1);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/locale/en-US.js
var kt = {
	...R,
	labels: {
		labelDayButton: (e, t, n, r) => {
			let i;
			i = r && typeof r.format == "function" ? r.format.bind(r) : (e, t) => pt(e, t, {
				locale: R,
				...n
			});
			let a = i(e, "PPPP");
			return t.today && (a = `Today, ${a}`), t.selected && (a = `${a}, selected`), a;
		},
		labelMonthDropdown: "Choose the Month",
		labelNext: "Go to the Next Month",
		labelPrevious: "Go to the Previous Month",
		labelWeekNumber: (e) => `Week ${e}`,
		labelYearDropdown: "Choose the Year",
		labelGrid: (e, t, n) => {
			let r;
			return r = n && typeof n.format == "function" ? n.format.bind(n) : (e, n) => pt(e, n, {
				locale: R,
				...t
			}), r(e, "LLLL yyyy");
		},
		labelGridcell: (e, t, n, r) => {
			let i;
			i = r && typeof r.format == "function" ? r.format.bind(r) : (e, t) => pt(e, t, {
				locale: R,
				...n
			});
			let a = i(e, "PPPP");
			return t?.today && (a = `Today, ${a}`), a;
		},
		labelNav: "Navigation bar",
		labelWeekNumberHeader: "Week Number",
		labelWeekday: (e, t, n) => {
			let r;
			return r = n && typeof n.format == "function" ? n.format.bind(n) : (e, n) => pt(e, n, {
				locale: R,
				...t
			}), r(e, "cccc");
		}
	}
}, U = class e {
	constructor(e, t) {
		this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? D.tz(this.options.timeZone) : new (this.options.Date ?? Date)(), this.newDate = (e, t, n) => this.overrides?.newDate ? this.overrides.newDate(e, t, n) : this.options.timeZone ? new D(e, t, n, this.options.timeZone) : new Date(e, t, n), this.addDays = (e, t) => this.overrides?.addDays ? this.overrides.addDays(e, t) : A(e, t), this.addMonths = (e, t) => this.overrides?.addMonths ? this.overrides.addMonths(e, t) : de(e, t), this.addWeeks = (e, t) => this.overrides?.addWeeks ? this.overrides.addWeeks(e, t) : _e(e, t), this.addYears = (e, t) => this.overrides?.addYears ? this.overrides.addYears(e, t) : ve(e, t), this.differenceInCalendarDays = (e, t) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(e, t) : he(e, t), this.differenceInCalendarMonths = (e, t) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(e, t) : we(e, t), this.eachMonthOfInterval = (e) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(e) : De(e), this.eachYearOfInterval = (e) => {
			let t = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(e) : je(e), n = new Set(t.map((e) => this.getYear(e)));
			if (n.size === t.length) return t;
			let r = [];
			return n.forEach((e) => {
				r.push(new Date(e, 0, 1));
			}), r;
		}, this.endOfBroadcastWeek = (e) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(e) : Ot(e, this), this.endOfISOWeek = (e) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(e) : Ne(e), this.endOfMonth = (e) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(e) : Te(e), this.endOfWeek = (e, t) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(e, t) : Me(e, this.options), this.endOfYear = (e) => this.overrides?.endOfYear ? this.overrides.endOfYear(e) : ke(e), this.format = (e, t, n) => {
			let r = this.overrides?.format ? this.overrides.format(e, t, this.options) : pt(e, t, this.options);
			return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(r) : r;
		}, this.getISOWeek = (e) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(e) : Ge(e), this.getMonth = (e, t) => this.overrides?.getMonth ? this.overrides.getMonth(e, this.options) : gt(e, this.options), this.getYear = (e, t) => this.overrides?.getYear ? this.overrides.getYear(e, this.options) : _t(e, this.options), this.getWeek = (e, t) => this.overrides?.getWeek ? this.overrides.getWeek(e, this.options) : Je(e, this.options), this.isAfter = (e, t) => this.overrides?.isAfter ? this.overrides.isAfter(e, t) : vt(e, t), this.isBefore = (e, t) => this.overrides?.isBefore ? this.overrides.isBefore(e, t) : yt(e, t), this.isDate = (e) => this.overrides?.isDate ? this.overrides.isDate(e) : Se(e), this.isSameDay = (e, t) => this.overrides?.isSameDay ? this.overrides.isSameDay(e, t) : xe(e, t), this.isSameMonth = (e, t) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(e, t) : bt(e, t), this.isSameYear = (e, t) => this.overrides?.isSameYear ? this.overrides.isSameYear(e, t) : xt(e, t), this.max = (e) => this.overrides?.max ? this.overrides.max(e) : ye(e), this.min = (e) => this.overrides?.min ? this.overrides.min(e) : be(e), this.setMonth = (e, t) => this.overrides?.setMonth ? this.overrides.setMonth(e, t) : St(e, t), this.setYear = (e, t) => this.overrides?.setYear ? this.overrides.setYear(e, t) : Ct(e, t), this.startOfBroadcastWeek = (e, t) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(e, this) : Dt(e, this), this.startOfDay = (e) => this.overrides?.startOfDay ? this.overrides.startOfDay(e) : F(e), this.startOfISOWeek = (e) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(e) : N(e), this.startOfMonth = (e) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(e) : Oe(e), this.startOfWeek = (e, t) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(e, this.options) : M(e, this.options), this.startOfYear = (e) => this.overrides?.startOfYear ? this.overrides.startOfYear(e) : Ae(e), this.options = {
			locale: kt,
			...e
		}, this.overrides = t;
	}
	getDigitMap() {
		let { numerals: e = "latn" } = this.options, t = new Intl.NumberFormat("en-US", { numberingSystem: e }), n = {};
		for (let e = 0; e < 10; e++) n[e.toString()] = t.format(e);
		return n;
	}
	replaceDigits(e) {
		let t = this.getDigitMap();
		return e.replace(/\d/g, (e) => t[e] || e);
	}
	formatNumber(e) {
		return this.replaceDigits(e.toString());
	}
	getMonthYearOrder() {
		let t = this.options.locale?.code;
		return t && e.yearFirstLocales.has(t) ? "year-first" : "month-first";
	}
	formatMonthYear(t) {
		let { locale: n, timeZone: r, numerals: i } = this.options, a = n?.code;
		if (a && e.yearFirstLocales.has(a)) try {
			return new Intl.DateTimeFormat(a, {
				month: "long",
				year: "numeric",
				timeZone: r,
				numberingSystem: i
			}).format(t);
		} catch {}
		let o = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
		return this.format(t, o);
	}
};
U.yearFirstLocales = /* @__PURE__ */ new Set([
	"eu",
	"hu",
	"ja",
	"ja-Hira",
	"ja-JP",
	"ko",
	"ko-KR",
	"lt",
	"lt-LT",
	"lv",
	"lv-LV",
	"mn",
	"mn-MN",
	"zh",
	"zh-CN",
	"zh-HK",
	"zh-TW"
]);
var W = new U(), At = class {
	constructor(e, t, n = W) {
		this.date = e, this.displayMonth = t, this.outside = !!(t && !n.isSameMonth(e, t)), this.dateLib = n, this.isoDate = n.format(e, "yyyy-MM-dd"), this.displayMonthId = n.format(t, "yyyy-MM"), this.dateMonthId = n.format(e, "yyyy-MM");
	}
	isEqualTo(e) {
		return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
	}
}, jt = class {
	constructor(e, t) {
		this.date = e, this.weeks = t;
	}
}, Mt = class {
	constructor(e, t) {
		this.days = t, this.weekNumber = e;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/CaptionLabel.js
function Nt(e) {
	return c.createElement("span", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Chevron.js
function Pt(e) {
	let { size: t = 24, orientation: n = "left", className: r, style: i } = e;
	return c.createElement("svg", {
		className: r,
		style: i,
		width: t,
		height: t,
		viewBox: "0 0 24 24"
	}, n === "up" && c.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }), n === "down" && c.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }), n === "left" && c.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }), n === "right" && c.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" }));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Day.js
function Ft(e) {
	let { day: t, modifiers: n, ...r } = e;
	return c.createElement("td", { ...r });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/DayButton.js
function It(e) {
	let { day: t, modifiers: n, ...r } = e, i = c.useRef(null);
	return c.useEffect(() => {
		n.focused && i.current?.focus();
	}, [n.focused]), c.createElement("button", {
		ref: i,
		...r
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/UI.js
var G;
(function(e) {
	e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(G ||= {});
var K;
(function(e) {
	e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(K ||= {});
var q;
(function(e) {
	e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(q ||= {});
var J;
(function(e) {
	e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(J ||= {});
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/useDayPicker.js
var Lt = l(void 0);
function Rt() {
	let e = d(Lt);
	if (e === void 0) throw Error("useDayPicker() must be used within a custom component.");
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Dropdown.js
function zt(e) {
	let { options: t, className: n, ...r } = e, { classNames: i, components: a, styles: o } = Rt(), s = [i[G.Dropdown], n].join(" "), l = t?.find(({ value: e }) => e === r.value);
	return c.createElement("span", {
		"data-disabled": r.disabled,
		className: i[G.DropdownRoot],
		style: o?.[G.DropdownRoot]
	}, c.createElement(a.Select, {
		className: s,
		...r
	}, t?.map(({ value: e, label: t, disabled: n }) => c.createElement(a.Option, {
		key: e,
		value: e,
		disabled: n
	}, t))), c.createElement("span", {
		className: i[G.CaptionLabel],
		style: o?.[G.CaptionLabel],
		"aria-hidden": !0
	}, l?.label, c.createElement(a.Chevron, {
		orientation: "down",
		size: 18,
		className: i[G.Chevron],
		style: o?.[G.Chevron]
	})));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/DropdownNav.js
function Bt(e) {
	return c.createElement("div", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Footer.js
function Vt(e) {
	return c.createElement("div", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Month.js
function Ht(e) {
	let { calendarMonth: t, displayIndex: n, ...r } = e;
	return c.createElement("div", { ...r }, e.children);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/MonthCaption.js
function Ut(e) {
	let { calendarMonth: t, displayIndex: n, ...r } = e;
	return c.createElement("div", { ...r });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/MonthGrid.js
function Wt(e) {
	return c.createElement("table", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Months.js
function Gt(e) {
	return c.createElement("div", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/MonthsDropdown.js
function Kt(e) {
	let { components: t } = Rt();
	return c.createElement(t.Dropdown, { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Nav.js
function qt(e) {
	let { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: i, ...a } = e, { components: o, classNames: s, styles: l, labels: { labelPrevious: d, labelNext: f } } = Rt(), p = u((e) => {
		i && n?.(e);
	}, [i, n]), m = u((e) => {
		r && t?.(e);
	}, [r, t]);
	return c.createElement("nav", { ...a }, c.createElement(o.PreviousMonthButton, {
		type: "button",
		className: s[G.PreviousMonthButton],
		style: l?.[G.PreviousMonthButton],
		tabIndex: r ? void 0 : -1,
		"aria-disabled": !r || void 0,
		"aria-label": d(r),
		onClick: m
	}, c.createElement(o.Chevron, {
		disabled: !r || void 0,
		className: s[G.Chevron],
		style: l?.[G.Chevron],
		orientation: "left"
	})), c.createElement(o.NextMonthButton, {
		type: "button",
		className: s[G.NextMonthButton],
		style: l?.[G.NextMonthButton],
		tabIndex: i ? void 0 : -1,
		"aria-disabled": !i || void 0,
		"aria-label": f(i),
		onClick: p
	}, c.createElement(o.Chevron, {
		disabled: !i || void 0,
		orientation: "right",
		className: s[G.Chevron],
		style: l?.[G.Chevron]
	})));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/NextMonthButton.js
function Jt(e) {
	return c.createElement("button", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Option.js
function Yt(e) {
	return c.createElement("option", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/PreviousMonthButton.js
function Xt(e) {
	return c.createElement("button", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Root.js
function Zt(e) {
	let { rootRef: t, ...n } = e;
	return c.createElement("div", {
		...n,
		ref: t
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Select.js
function Qt(e) {
	return c.createElement("select", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Week.js
function $t(e) {
	let { week: t, ...n } = e;
	return c.createElement("tr", { ...n });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Weekday.js
function en(e) {
	return c.createElement("th", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Weekdays.js
function tn(e) {
	return c.createElement("thead", { "aria-hidden": !0 }, c.createElement("tr", { ...e }));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/WeekNumber.js
function nn(e) {
	let { week: t, ...n } = e;
	return c.createElement("th", { ...n });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/WeekNumberHeader.js
function rn(e) {
	return c.createElement("th", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/Weeks.js
function an(e) {
	return c.createElement("tbody", { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/YearsDropdown.js
function on(e) {
	let { components: t } = Rt();
	return c.createElement(t.Dropdown, { ...e });
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/components/custom-components.js
var sn = /* @__PURE__ */ e({
	CaptionLabel: () => Nt,
	Chevron: () => Pt,
	Day: () => Ft,
	DayButton: () => It,
	Dropdown: () => zt,
	DropdownNav: () => Bt,
	Footer: () => Vt,
	Month: () => Ht,
	MonthCaption: () => Ut,
	MonthGrid: () => Wt,
	Months: () => Gt,
	MonthsDropdown: () => Kt,
	Nav: () => qt,
	NextMonthButton: () => Jt,
	Option: () => Yt,
	PreviousMonthButton: () => Xt,
	Root: () => Zt,
	Select: () => Qt,
	Week: () => $t,
	WeekNumber: () => nn,
	WeekNumberHeader: () => rn,
	Weekday: () => en,
	Weekdays: () => tn,
	Weeks: () => an,
	YearsDropdown: () => on
});
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/utils/rangeIncludesDate.js
function Y(e, t, n = !1, r = W) {
	let { from: i, to: a } = e, { differenceInCalendarDays: o, isSameDay: s } = r;
	return i && a ? (o(a, i) < 0 && ([i, a] = [a, i]), o(t, i) >= +!!n && o(a, t) >= +!!n) : !n && a ? s(a, t) : !n && i ? s(i, t) : !1;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/utils/typeguards.js
function cn(e) {
	return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function ln(e) {
	return !!(e && typeof e == "object" && "from" in e);
}
function un(e) {
	return !!(e && typeof e == "object" && "after" in e);
}
function dn(e) {
	return !!(e && typeof e == "object" && "before" in e);
}
function fn(e) {
	return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function pn(e, t) {
	return Array.isArray(e) && e.every(t.isDate);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/utils/dateMatchModifiers.js
function X(e, t, n = W) {
	let r = Array.isArray(t) ? t : [t], { isSameDay: i, differenceInCalendarDays: a, isAfter: o } = n;
	return r.some((t) => {
		if (typeof t == "boolean") return t;
		if (n.isDate(t)) return i(e, t);
		if (pn(t, n)) return t.some((t) => i(e, t));
		if (ln(t)) return Y(t, e, !1, n);
		if (fn(t)) return Array.isArray(t.dayOfWeek) ? t.dayOfWeek.includes(e.getDay()) : t.dayOfWeek === e.getDay();
		if (cn(t)) {
			let n = a(t.before, e), r = a(t.after, e), i = n > 0, s = r < 0;
			return o(t.before, t.after) ? s && i : i || s;
		}
		return un(t) ? a(e, t.after) > 0 : dn(t) ? a(t.before, e) > 0 : typeof t == "function" && t(e);
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/createGetModifiers.js
function mn(e, t, n, r, i) {
	let { disabled: a, hidden: o, modifiers: s, showOutsideDays: c, broadcastCalendar: l, today: u = i.today() } = t, { isSameDay: d, isSameMonth: f, startOfMonth: p, isBefore: m, endOfMonth: h, isAfter: g } = i, _ = n && p(n), v = r && h(r), y = {
		[K.focused]: [],
		[K.outside]: [],
		[K.disabled]: [],
		[K.hidden]: [],
		[K.today]: []
	}, b = {};
	for (let t of e) {
		let { date: e, displayMonth: n } = t, r = !!(n && !f(e, n)), p = !!(_ && m(e, _)), h = !!(v && g(e, v)), x = !!(a && X(e, a, i)), S = !!(o && X(e, o, i)) || p || h || !l && !c && r || l && c === !1 && r, C = d(e, u);
		r && y.outside.push(t), x && y.disabled.push(t), S && y.hidden.push(t), C && y.today.push(t), s && Object.keys(s).forEach((n) => {
			let r = s?.[n];
			r && X(e, r, i) && (b[n] ? b[n].push(t) : b[n] = [t]);
		});
	}
	return (e) => {
		let t = {
			[K.focused]: !1,
			[K.disabled]: !1,
			[K.hidden]: !1,
			[K.outside]: !1,
			[K.today]: !1
		}, n = {};
		for (let n in y) t[n] = y[n].some((t) => t === e);
		for (let t in b) n[t] = b[t].some((t) => t === e);
		return {
			...t,
			...n
		};
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getClassNamesForModifiers.js
function hn(e, t, n = {}) {
	return Object.entries(e).filter(([, e]) => e === !0).reduce((e, [r]) => (n[r] ? e.push(n[r]) : t[K[r]] ? e.push(t[K[r]]) : t[q[r]] && e.push(t[q[r]]), e), [t[G.Day]]);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getComponents.js
function gn(e) {
	return {
		...sn,
		...e
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getDataAttributes.js
function _n(e) {
	let t = {
		"data-mode": e.mode ?? void 0,
		"data-required": "required" in e ? e.required : void 0,
		"data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
		"data-week-numbers": e.showWeekNumber || void 0,
		"data-broadcast-calendar": e.broadcastCalendar || void 0,
		"data-nav-layout": e.navLayout || void 0
	};
	return Object.entries(e).forEach(([e, n]) => {
		e.startsWith("data-") && (t[e] = n);
	}), t;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getDefaultClassNames.js
function vn() {
	let e = {};
	for (let t in G) e[G[t]] = `rdp-${G[t]}`;
	for (let t in K) e[K[t]] = `rdp-${K[t]}`;
	for (let t in q) e[q[t]] = `rdp-${q[t]}`;
	for (let t in J) e[J[t]] = `rdp-${J[t]}`;
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/formatters/formatCaption.js
function yn(e, t, n) {
	return (n ?? new U(t)).formatMonthYear(e);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/formatters/formatDay.js
function bn(e, t, n) {
	return (n ?? new U(t)).format(e, "d");
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/formatters/formatMonthDropdown.js
function xn(e, t = W) {
	return t.format(e, "LLLL");
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/formatters/formatWeekdayName.js
function Sn(e, t, n) {
	return (n ?? new U(t)).format(e, "cccccc");
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/formatters/formatWeekNumber.js
function Cn(e, t = W) {
	return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/formatters/formatWeekNumberHeader.js
function wn() {
	return "";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/formatters/formatYearDropdown.js
function Tn(e, t = W) {
	return t.format(e, "yyyy");
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/formatters/index.js
var En = /* @__PURE__ */ e({
	formatCaption: () => yn,
	formatDay: () => bn,
	formatMonthDropdown: () => xn,
	formatWeekNumber: () => Cn,
	formatWeekNumberHeader: () => wn,
	formatWeekdayName: () => Sn,
	formatYearDropdown: () => Tn
});
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getFormatters.js
function Dn(e) {
	return {
		...En,
		...e
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelDayButton.js
function On(e, t, n, r) {
	let i = (r ?? new U(n)).format(e, "PPPP");
	return t.today && (i = `Today, ${i}`), t.selected && (i = `${i}, selected`), i;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelGrid.js
function kn(e, t, n) {
	return (n ?? new U(t)).formatMonthYear(e);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelGridcell.js
function An(e, t, n, r) {
	let i = (r ?? new U(n)).format(e, "PPPP");
	return t?.today && (i = `Today, ${i}`), i;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelMonthDropdown.js
function jn(e) {
	return "Choose the Month";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelNav.js
function Mn() {
	return "";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelNext.js
var Nn = "Go to the Next Month";
function Pn(e, t) {
	return Nn;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelPrevious.js
function Fn(e) {
	return "Go to the Previous Month";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelWeekday.js
function In(e, t, n) {
	return (n ?? new U(t)).format(e, "cccc");
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelWeekNumber.js
function Ln(e, t) {
	return `Week ${e}`;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelWeekNumberHeader.js
function Rn(e) {
	return "Week Number";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/labelYearDropdown.js
function zn(e) {
	return "Choose the Year";
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/labels/index.js
var Bn = /* @__PURE__ */ e({
	labelDayButton: () => On,
	labelGrid: () => kn,
	labelGridcell: () => An,
	labelMonthDropdown: () => jn,
	labelNav: () => Mn,
	labelNext: () => Pn,
	labelPrevious: () => Fn,
	labelWeekNumber: () => Ln,
	labelWeekNumberHeader: () => Rn,
	labelWeekday: () => In,
	labelYearDropdown: () => zn
}), Z = (e, t, n) => t || (n ? typeof n == "function" ? n : (...e) => n : e);
function Vn(e, t) {
	let n = t.locale?.labels ?? {};
	return {
		...Bn,
		...e ?? {},
		labelDayButton: Z(On, e?.labelDayButton, n.labelDayButton),
		labelMonthDropdown: Z(jn, e?.labelMonthDropdown, n.labelMonthDropdown),
		labelNext: Z(Pn, e?.labelNext, n.labelNext),
		labelPrevious: Z(Fn, e?.labelPrevious, n.labelPrevious),
		labelWeekNumber: Z(Ln, e?.labelWeekNumber, n.labelWeekNumber),
		labelYearDropdown: Z(zn, e?.labelYearDropdown, n.labelYearDropdown),
		labelGrid: Z(kn, e?.labelGrid, n.labelGrid),
		labelGridcell: Z(An, e?.labelGridcell, n.labelGridcell),
		labelNav: Z(Mn, e?.labelNav, n.labelNav),
		labelWeekNumberHeader: Z(Rn, e?.labelWeekNumberHeader, n.labelWeekNumberHeader),
		labelWeekday: Z(In, e?.labelWeekday, n.labelWeekday)
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getMonthOptions.js
function Hn(e, t, n, r, i) {
	let { startOfMonth: a, startOfYear: o, endOfYear: s, eachMonthOfInterval: c, getMonth: l } = i;
	return c({
		start: o(e),
		end: s(e)
	}).map((e) => {
		let o = r.formatMonthDropdown(e, i);
		return {
			value: l(e),
			label: o,
			disabled: t && e < a(t) || n && e > a(n) || !1
		};
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getStyleForModifiers.js
function Un(e, t = {}, n = {}) {
	let r = { ...t?.[G.Day] };
	return Object.entries(e).filter(([, e]) => e === !0).forEach(([e]) => {
		r = {
			...r,
			...n?.[e]
		};
	}), r;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getWeekdays.js
function Wn(e, t, n, r) {
	let i = r ?? e.today(), a = n ? e.startOfBroadcastWeek(i, e) : t ? e.startOfISOWeek(i) : e.startOfWeek(i), o = [];
	for (let t = 0; t < 7; t++) {
		let n = e.addDays(a, t);
		o.push(n);
	}
	return o;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getYearOptions.js
function Gn(e, t, n, r, i = !1) {
	if (!e || !t) return;
	let { startOfYear: a, endOfYear: o, eachYearOfInterval: s, getYear: c } = r, l = s({
		start: a(e),
		end: o(t)
	});
	return i && l.reverse(), l.map((e) => {
		let t = n.formatYearDropdown(e, r);
		return {
			value: c(e),
			label: t,
			disabled: !1
		};
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/noonDateLib.js
function Kn(e, t = {}) {
	let { weekStartsOn: n, locale: r } = t, i = n ?? r?.options?.weekStartsOn ?? 0, a = (t) => {
		let n = typeof t == "number" || typeof t == "string" ? new Date(t) : t;
		return new D(n.getFullYear(), n.getMonth(), n.getDate(), 12, 0, 0, e);
	}, o = (e) => {
		let t = a(e);
		return new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0, 0, 0);
	};
	return {
		today: () => a(D.tz(e)),
		newDate: (t, n, r) => new D(t, n, r, 12, 0, 0, e),
		startOfDay: (e) => a(e),
		startOfWeek: (e, t) => {
			let n = a(e), r = t?.weekStartsOn ?? i, o = (n.getDay() - r + 7) % 7;
			return n.setDate(n.getDate() - o), n;
		},
		startOfISOWeek: (e) => {
			let t = a(e), n = (t.getDay() - 1 + 7) % 7;
			return t.setDate(t.getDate() - n), t;
		},
		startOfMonth: (e) => {
			let t = a(e);
			return t.setDate(1), t;
		},
		startOfYear: (e) => {
			let t = a(e);
			return t.setMonth(0, 1), t;
		},
		endOfWeek: (e, t) => {
			let n = a(e), r = (((t?.weekStartsOn ?? i) + 6) % 7 - n.getDay() + 7) % 7;
			return n.setDate(n.getDate() + r), n;
		},
		endOfISOWeek: (e) => {
			let t = a(e), n = (7 - t.getDay()) % 7;
			return t.setDate(t.getDate() + n), t;
		},
		endOfMonth: (e) => {
			let t = a(e);
			return t.setMonth(t.getMonth() + 1, 0), t;
		},
		endOfYear: (e) => {
			let t = a(e);
			return t.setMonth(11, 31), t;
		},
		eachMonthOfInterval: (t) => {
			let n = a(t.start), r = a(t.end), i = [], o = new D(n.getFullYear(), n.getMonth(), 1, 12, 0, 0, e), s = r.getFullYear() * 12 + r.getMonth();
			for (; o.getFullYear() * 12 + o.getMonth() <= s;) i.push(new D(o, e)), o.setMonth(o.getMonth() + 1, 1);
			return i;
		},
		addDays: (e, t) => {
			let n = a(e);
			return n.setDate(n.getDate() + t), n;
		},
		addWeeks: (e, t) => {
			let n = a(e);
			return n.setDate(n.getDate() + t * 7), n;
		},
		addMonths: (e, t) => {
			let n = a(e);
			return n.setMonth(n.getMonth() + t), n;
		},
		addYears: (e, t) => {
			let n = a(e);
			return n.setFullYear(n.getFullYear() + t), n;
		},
		eachYearOfInterval: (t) => {
			let n = a(t.start), r = a(t.end), i = [], o = new D(n.getFullYear(), 0, 1, 12, 0, 0, e);
			for (; o.getFullYear() <= r.getFullYear();) i.push(new D(o, e)), o.setFullYear(o.getFullYear() + 1, 0, 1);
			return i;
		},
		getWeek: (e, t) => Je(o(e), {
			weekStartsOn: t?.weekStartsOn ?? i,
			firstWeekContainsDate: t?.firstWeekContainsDate ?? r?.options?.firstWeekContainsDate ?? 1
		}),
		getISOWeek: (e) => Ge(o(e)),
		differenceInCalendarDays: (e, t) => he(o(e), o(t)),
		differenceInCalendarMonths: (e, t) => we(o(e), o(t))
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/useAnimation.js
var qn = (e) => e instanceof HTMLElement ? e : null, Jn = (e) => [...e.querySelectorAll("[data-animated-month]") ?? []], Yn = (e) => qn(e.querySelector("[data-animated-month]")), Xn = (e) => qn(e.querySelector("[data-animated-caption]")), Zn = (e) => qn(e.querySelector("[data-animated-weeks]")), Qn = (e) => qn(e.querySelector("[data-animated-nav]")), $n = (e) => qn(e.querySelector("[data-animated-weekdays]"));
function er(e, t, { classNames: n, months: r, focused: i, dateLib: a }) {
	let o = h(null), s = h(r), c = h(!1);
	p(() => {
		let l = s.current;
		if (s.current = r, !t || !e.current || !(e.current instanceof HTMLElement) || r.length === 0 || l.length === 0 || r.length !== l.length) return;
		let u = a.isSameMonth(r[0].date, l[0].date), d = a.isAfter(r[0].date, l[0].date), f = d ? n[J.caption_after_enter] : n[J.caption_before_enter], p = d ? n[J.weeks_after_enter] : n[J.weeks_before_enter], m = o.current, h = e.current.cloneNode(!0);
		if (h instanceof HTMLElement ? (Jn(h).forEach((e) => {
			if (!(e instanceof HTMLElement)) return;
			let t = Yn(e);
			t && e.contains(t) && e.removeChild(t);
			let n = Xn(e);
			n && n.classList.remove(f);
			let r = Zn(e);
			r && r.classList.remove(p);
		}), o.current = h) : o.current = null, c.current || u || i) return;
		let g = m instanceof HTMLElement ? Jn(m) : [], _ = Jn(e.current);
		if (_?.every((e) => e instanceof HTMLElement) && g?.every((e) => e instanceof HTMLElement)) {
			c.current = !0;
			let t = [];
			e.current.style.isolation = "isolate";
			let r = Qn(e.current);
			r && (r.style.zIndex = "1"), _.forEach((i, a) => {
				let o = g[a];
				if (!o) return;
				i.style.position = "relative", i.style.overflow = "hidden";
				let s = Xn(i);
				s && s.classList.add(f);
				let l = Zn(i);
				l && l.classList.add(p);
				let u = () => {
					c.current = !1, e.current && (e.current.style.isolation = ""), r && (r.style.zIndex = ""), s && s.classList.remove(f), l && l.classList.remove(p), i.style.position = "", i.style.overflow = "", i.contains(o) && i.removeChild(o);
				};
				t.push(u), o.style.pointerEvents = "none", o.style.position = "absolute", o.style.overflow = "hidden", o.setAttribute("aria-hidden", "true");
				let m = $n(o);
				m && (m.style.opacity = "0");
				let h = Xn(o);
				h && (h.classList.add(d ? n[J.caption_before_exit] : n[J.caption_after_exit]), h.addEventListener("animationend", u));
				let _ = Zn(o);
				_ && _.classList.add(d ? n[J.weeks_before_exit] : n[J.weeks_after_exit]), i.insertBefore(o, i.firstChild);
			});
		}
	});
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getDates.js
function tr(e, t, n, r) {
	let i = e[0], a = e[e.length - 1], { ISOWeek: o, fixedWeeks: s, broadcastCalendar: c } = n ?? {}, { addDays: l, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: f, endOfISOWeek: p, endOfMonth: m, endOfWeek: h, isAfter: g, startOfBroadcastWeek: _, startOfISOWeek: v, startOfWeek: y } = r, b = c ? _(i, r) : o ? v(i) : y(i), x = c ? f(a) : o ? p(m(a)) : h(m(a)), S = t && (c ? f(t) : o ? p(t) : h(t)), C = u(S && g(x, S) ? S : x, b), w = d(a, i) + 1, T = [];
	for (let e = 0; e <= C; e++) {
		let t = l(b, e);
		T.push(t);
	}
	let E = (c ? 35 : 42) * w;
	if (s && T.length < E) {
		let e = E - T.length;
		for (let t = 0; t < e; t++) {
			let e = l(T[T.length - 1], 1);
			T.push(e);
		}
	}
	return T;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getDays.js
function nr(e) {
	let t = [];
	return e.reduce((e, n) => {
		let r = n.weeks.reduce((e, t) => e.concat(t.days.slice()), t.slice());
		return e.concat(r.slice());
	}, t.slice());
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getDisplayMonths.js
function rr(e, t, n, r) {
	let { numberOfMonths: i = 1 } = n, a = [];
	for (let n = 0; n < i; n++) {
		let i = r.addMonths(e, n);
		if (t && i > t) break;
		a.push(i);
	}
	return a;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getInitialMonth.js
function ir(e, t, n, r) {
	let { month: i, defaultMonth: a, today: o = r.today(), numberOfMonths: s = 1 } = e, c = i || a || o, { differenceInCalendarMonths: l, addMonths: u, startOfMonth: d } = r;
	return n && l(n, c) < s - 1 && (c = u(n, -1 * (s - 1))), t && l(c, t) < 0 && (c = t), d(c);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getMonths.js
function ar(e, t, n, r) {
	let { addDays: i, endOfBroadcastWeek: a, endOfISOWeek: o, endOfMonth: s, endOfWeek: c, getISOWeek: l, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: f, startOfWeek: p } = r, m = e.reduce((e, m) => {
		let h = n.broadcastCalendar ? d(m, r) : n.ISOWeek ? f(m) : p(m), g = n.broadcastCalendar ? a(m) : n.ISOWeek ? o(s(m)) : c(s(m)), _ = t.filter((e) => e >= h && e <= g), v = n.broadcastCalendar ? 35 : 42;
		if (n.fixedWeeks && _.length < v) {
			let e = t.filter((e) => {
				let t = v - _.length;
				return e > g && e <= i(g, t);
			});
			_.push(...e);
		}
		let y = new jt(m, _.reduce((e, t) => {
			let i = n.ISOWeek ? l(t) : u(t), a = e.find((e) => e.weekNumber === i), o = new At(t, m, r);
			return a ? a.days.push(o) : e.push(new Mt(i, [o])), e;
		}, []));
		return e.push(y), e;
	}, []);
	return n.reverseMonths ? m.reverse() : m;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getNavMonth.js
function or(e, t) {
	let { startMonth: n, endMonth: r } = e, { startOfYear: i, startOfDay: a, startOfMonth: o, endOfMonth: s, addYears: c, endOfYear: l, today: u } = t, d = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
	return n ? n = o(n) : !n && d && (n = i(c(e.today ?? u(), -100))), r ? r = s(r) : !r && d && (r = l(e.today ?? u())), [n && a(n), r && a(r)];
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getNextMonth.js
function sr(e, t, n, r) {
	if (n.disableNavigation) return;
	let { pagedNavigation: i, numberOfMonths: a = 1 } = n, { startOfMonth: o, addMonths: s, differenceInCalendarMonths: c } = r, l = i ? a : 1, u = o(e);
	if (!t || !(c(t, e) < a)) return s(u, l);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getPreviousMonth.js
function cr(e, t, n, r) {
	if (n.disableNavigation) return;
	let { pagedNavigation: i, numberOfMonths: a } = n, { startOfMonth: o, addMonths: s, differenceInCalendarMonths: c } = r, l = i ? a ?? 1 : 1, u = o(e);
	if (!t || !(c(u, t) <= 0)) return s(u, -l);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getWeeks.js
function lr(e) {
	return e.reduce((e, t) => e.concat(t.weeks.slice()), [].slice());
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/useControlledValue.js
function ur(e, t) {
	let [n, r] = g(e);
	return [t === void 0 ? n : t, r];
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/useCalendar.js
function dr(e, t) {
	let [n, r] = or(e, t), { startOfMonth: i, endOfMonth: a } = t, o = ir(e, n, r, t), [s, c] = ur(o, e.month ? o : void 0);
	f(() => {
		let i = ir(e, n, r, t);
		c(i);
	}, [e.timeZone]);
	let { months: l, weeks: u, days: d, previousMonth: p, nextMonth: h } = m(() => {
		let i = rr(s, r, { numberOfMonths: e.numberOfMonths }, t), o = ar(i, tr(i, e.endMonth ? a(e.endMonth) : void 0, {
			ISOWeek: e.ISOWeek,
			fixedWeeks: e.fixedWeeks,
			broadcastCalendar: e.broadcastCalendar
		}, t), {
			broadcastCalendar: e.broadcastCalendar,
			fixedWeeks: e.fixedWeeks,
			ISOWeek: e.ISOWeek,
			reverseMonths: e.reverseMonths
		}, t);
		return {
			months: o,
			weeks: lr(o),
			days: nr(o),
			previousMonth: cr(s, n, e, t),
			nextMonth: sr(s, r, e, t)
		};
	}, [
		t,
		s.getTime(),
		r?.getTime(),
		n?.getTime(),
		e.disableNavigation,
		e.broadcastCalendar,
		e.endMonth?.getTime(),
		e.fixedWeeks,
		e.ISOWeek,
		e.numberOfMonths,
		e.pagedNavigation,
		e.reverseMonths
	]), { disableNavigation: g, onMonthChange: _ } = e, v = (e) => u.some((t) => t.days.some((t) => t.isEqualTo(e))), y = (e) => {
		if (g) return;
		let t = i(e);
		n && t < i(n) && (t = i(n)), r && t > i(r) && (t = i(r)), c(t), _?.(t);
	};
	return {
		months: l,
		weeks: u,
		days: d,
		navStart: n,
		navEnd: r,
		previousMonth: p,
		nextMonth: h,
		goToMonth: y,
		goToDay: (e) => {
			v(e) || y(e.date);
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/calculateFocusTarget.js
var Q;
(function(e) {
	e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(Q ||= {});
function fr(e) {
	return !e[K.disabled] && !e[K.hidden] && !e[K.outside];
}
function pr(e, t, n, r) {
	let i, a = -1;
	for (let o of e) {
		let e = t(o);
		fr(e) && (e[K.focused] && a < Q.FocusedModifier ? (i = o, a = Q.FocusedModifier) : r?.isEqualTo(o) && a < Q.LastFocused ? (i = o, a = Q.LastFocused) : n(o.date) && a < Q.Selected ? (i = o, a = Q.Selected) : e[K.today] && a < Q.Today && (i = o, a = Q.Today));
	}
	return i ||= e.find((e) => fr(t(e))), i;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getFocusableDate.js
function mr(e, t, n, r, i, a, o) {
	let { ISOWeek: s, broadcastCalendar: c } = a, { addDays: l, addMonths: u, addWeeks: d, addYears: f, endOfBroadcastWeek: p, endOfISOWeek: m, endOfWeek: h, max: g, min: _, startOfBroadcastWeek: v, startOfISOWeek: y, startOfWeek: b } = o, x = {
		day: l,
		week: d,
		month: u,
		year: f,
		startOfWeek: (e) => c ? v(e, o) : s ? y(e) : b(e),
		endOfWeek: (e) => c ? p(e) : s ? m(e) : h(e)
	}[e](n, t === "after" ? 1 : -1);
	return t === "before" && r ? x = g([r, x]) : t === "after" && i && (x = _([i, x])), x;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/helpers/getNextFocus.js
function hr(e, t, n, r, i, a, o, s = 0) {
	if (s > 365) return;
	let c = mr(e, t, n.date, r, i, a, o), l = !!(a.disabled && X(c, a.disabled, o)), u = !!(a.hidden && X(c, a.hidden, o)), d = new At(c, c, o);
	return !l && !u ? d : hr(e, t, d, r, i, a, o, s + 1);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/useFocus.js
function gr(e, t, n, r, i) {
	let { autoFocus: a } = e, [o, s] = g(), c = pr(t.days, n, r || (() => !1), o), [l, u] = g(a ? c : void 0);
	return {
		isFocusTarget: (e) => !!c?.isEqualTo(e),
		setFocused: u,
		focused: l,
		blur: () => {
			s(l), u(void 0);
		},
		moveFocus: (n, r) => {
			if (!l) return;
			let a = hr(n, r, l, t.navStart, t.navEnd, e, i);
			a && (e.disableNavigation && !t.days.some((e) => e.isEqualTo(a)) || (t.goToDay(a), u(a)));
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/selection/useMulti.js
function _r(e, t) {
	let { selected: n, required: r, onSelect: i } = e, [a, o] = ur(n, i ? n : void 0), s = i ? n : a, { isSameDay: c } = t, l = (e) => s?.some((t) => c(t, e)) ?? !1, { min: u, max: d } = e;
	return {
		selected: s,
		select: (e, t, n) => {
			let a = [...s ?? []];
			if (l(e)) {
				if (s?.length === u || r && s?.length === 1) return;
				a = s?.filter((t) => !c(t, e));
			} else a = s?.length === d ? [e] : [...a, e];
			return i || o(a), i?.(a, e, t, n), a;
		},
		isSelected: l
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/utils/addToRange.js
function vr(e, t, n = 0, r = 0, i = !1, a = W) {
	let { from: o, to: s } = t || {}, { isSameDay: c, isAfter: l, isBefore: u } = a, d;
	if (!o && !s) d = {
		from: e,
		to: n > 0 ? void 0 : e
	};
	else if (o && !s) d = c(o, e) ? n === 0 ? {
		from: o,
		to: e
	} : i ? {
		from: o,
		to: void 0
	} : void 0 : u(e, o) ? {
		from: e,
		to: o
	} : {
		from: o,
		to: e
	};
	else if (o && s) if (c(o, e) && c(s, e)) d = i ? {
		from: o,
		to: s
	} : void 0;
	else if (c(o, e)) d = {
		from: o,
		to: n > 0 ? void 0 : e
	};
	else if (c(s, e)) d = {
		from: e,
		to: n > 0 ? void 0 : e
	};
	else if (u(e, o)) d = {
		from: e,
		to: s
	};
	else if (l(e, o)) d = {
		from: o,
		to: e
	};
	else if (l(e, s)) d = {
		from: o,
		to: e
	};
	else throw Error("Invalid range");
	if (d?.from && d?.to) {
		let t = a.differenceInCalendarDays(d.to, d.from);
		(r > 0 && t > r || n > 1 && t < n) && (d = {
			from: e,
			to: void 0
		});
	}
	return d;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/utils/rangeContainsDayOfWeek.js
function yr(e, t, n = W) {
	let r = Array.isArray(t) ? t : [t], i = e.from, a = n.differenceInCalendarDays(e.to, e.from), o = Math.min(a, 6);
	for (let e = 0; e <= o; e++) {
		if (r.includes(i.getDay())) return !0;
		i = n.addDays(i, 1);
	}
	return !1;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/utils/rangeOverlaps.js
function br(e, t, n = W) {
	return Y(e, t.from, !1, n) || Y(e, t.to, !1, n) || Y(t, e.from, !1, n) || Y(t, e.to, !1, n);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/utils/rangeContainsModifiers.js
function xr(e, t, n = W) {
	let r = Array.isArray(t) ? t : [t];
	if (r.filter((e) => typeof e != "function").some((t) => typeof t == "boolean" ? t : n.isDate(t) ? Y(e, t, !1, n) : pn(t, n) ? t.some((t) => Y(e, t, !1, n)) : ln(t) ? t.from && t.to ? br(e, {
		from: t.from,
		to: t.to
	}, n) : !1 : fn(t) ? yr(e, t.dayOfWeek, n) : cn(t) ? n.isAfter(t.before, t.after) ? br(e, {
		from: n.addDays(t.after, 1),
		to: n.addDays(t.before, -1)
	}, n) : X(e.from, t, n) || X(e.to, t, n) : un(t) || dn(t) ? X(e.from, t, n) || X(e.to, t, n) : !1)) return !0;
	let i = r.filter((e) => typeof e == "function");
	if (i.length) {
		let t = e.from, r = n.differenceInCalendarDays(e.to, e.from);
		for (let e = 0; e <= r; e++) {
			if (i.some((e) => e(t))) return !0;
			t = n.addDays(t, 1);
		}
	}
	return !1;
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/selection/useRange.js
function Sr(e, t) {
	let { disabled: n, excludeDisabled: r, resetOnSelect: i, selected: a, required: o, onSelect: s } = e, [c, l] = ur(a, s ? a : void 0), u = s ? a : c;
	return {
		selected: u,
		select: (a, c, d) => {
			let { min: f, max: p } = e, m;
			if (a) {
				let e = u?.from, n = u?.to, r = !!e && !!n, s = !!e && !!n && t.isSameDay(e, n) && t.isSameDay(a, e);
				m = i && (r || !u?.from) ? !o && s ? void 0 : {
					from: a,
					to: void 0
				} : vr(a, u, f, p, o, t);
			}
			return r && n && m?.from && m.to && xr({
				from: m.from,
				to: m.to
			}, n, t) && (m.from = a, m.to = void 0), s || l(m), s?.(m, a, c, d), m;
		},
		isSelected: (e) => u && Y(u, e, !1, t)
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/selection/useSingle.js
function Cr(e, t) {
	let { selected: n, required: r, onSelect: i } = e, [a, o] = ur(n, i ? n : void 0), s = i ? n : a, { isSameDay: c } = t;
	return {
		selected: s,
		select: (e, t, n) => {
			let a = e;
			return !r && s && s && c(e, s) && (a = void 0), i || o(a), i?.(a, e, t, n), a;
		},
		isSelected: (e) => s ? c(s, e) : !1
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/useSelection.js
function wr(e, t) {
	let n = Cr(e, t), r = _r(e, t), i = Sr(e, t);
	switch (e.mode) {
		case "single": return n;
		case "multiple": return r;
		case "range": return i;
		default: return;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/utils/toTimeZone.js
function $(e, t) {
	return e instanceof D && e.timeZone === t ? e : new D(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/utils/convertMatchersToTimeZone.js
function Tr(e, t, n) {
	if (!n) return $(e, t);
	let r = $(e, t), i = new D(r.getFullYear(), r.getMonth(), r.getDate(), 12, 0, 0, t);
	return new Date(i.getTime());
}
function Er(e, t, n) {
	return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? Tr(e, t, n) : Array.isArray(e) ? e.map((e) => e instanceof Date ? Tr(e, t, n) : e) : ln(e) ? {
		...e,
		from: e.from ? $(e.from, t) : e.from,
		to: e.to ? $(e.to, t) : e.to
	} : cn(e) ? {
		before: Tr(e.before, t, n),
		after: Tr(e.after, t, n)
	} : un(e) ? { after: Tr(e.after, t, n) } : dn(e) ? { before: Tr(e.before, t, n) } : e;
}
function Dr(e, t, n) {
	return e && (Array.isArray(e) ? e.map((e) => Er(e, t, n)) : Er(e, t, n));
}
//#endregion
//#region ../../node_modules/.pnpm/react-day-picker@10.0.1_@types+react@19.2.17_react@19.2.7/node_modules/react-day-picker/dist/esm/DayPicker.js
function Or(e) {
	let t = e, n = t.timeZone;
	if (n && (t = {
		...e,
		timeZone: n
	}, t.today &&= $(t.today, n), t.month &&= $(t.month, n), t.defaultMonth &&= $(t.defaultMonth, n), t.startMonth &&= $(t.startMonth, n), t.endMonth &&= $(t.endMonth, n), t.mode === "single" && t.selected ? t.selected = $(t.selected, n) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((e) => $(e, n)) : t.mode === "range" && t.selected && (t.selected = {
		from: t.selected.from ? $(t.selected.from, n) : t.selected.from,
		to: t.selected.to ? $(t.selected.to, n) : t.selected.to
	}), t.disabled !== void 0 && (t.disabled = Dr(t.disabled, n)), t.hidden !== void 0 && (t.hidden = Dr(t.hidden, n)), t.modifiers)) {
		let e = {};
		Object.keys(t.modifiers).forEach((r) => {
			e[r] = Dr(t.modifiers?.[r], n);
		}), t.modifiers = e;
	}
	let { components: r, formatters: i, labels: a, dateLib: o, locale: s, classNames: l } = m(() => {
		let e = {
			...kt,
			...t.locale
		}, n = t.broadcastCalendar ? 1 : t.weekStartsOn, r = t.noonSafe && t.timeZone ? Kn(t.timeZone, {
			weekStartsOn: n,
			locale: e
		}) : void 0, i = t.dateLib && r ? {
			...r,
			...t.dateLib
		} : t.dateLib ?? r, a = new U({
			locale: e,
			weekStartsOn: n,
			firstWeekContainsDate: t.firstWeekContainsDate,
			useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
			useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
			timeZone: t.timeZone,
			numerals: t.numerals
		}, i);
		return {
			dateLib: a,
			components: gn(t.components),
			formatters: Dn(t.formatters),
			labels: Vn(t.labels, a.options),
			locale: e,
			classNames: {
				...vn(),
				...t.classNames
			}
		};
	}, [
		t.locale,
		t.broadcastCalendar,
		t.weekStartsOn,
		t.firstWeekContainsDate,
		t.useAdditionalWeekYearTokens,
		t.useAdditionalDayOfYearTokens,
		t.timeZone,
		t.numerals,
		t.dateLib,
		t.noonSafe,
		t.components,
		t.formatters,
		t.labels,
		t.classNames
	]);
	t.today || (t = {
		...t,
		today: o.today()
	});
	let { captionLayout: d, mode: f, navLayout: p, numberOfMonths: g = 1, onDayBlur: _, onDayClick: v, onDayFocus: y, onDayKeyDown: b, onDayMouseEnter: x, onDayMouseLeave: S, onNextClick: C, onPrevClick: w, showWeekNumber: T, styles: E } = t, { formatCaption: ee, formatDay: te, formatMonthDropdown: ne, formatWeekNumber: re, formatWeekNumberHeader: D, formatWeekdayName: ie, formatYearDropdown: ae } = i, oe = dr(t, o), { days: se, months: ce, navStart: le, navEnd: ue, previousMonth: O, nextMonth: k, goToMonth: A } = oe, de = mn(se, t, le, ue, o), { isSelected: fe, select: j, selected: M } = wr(t, o) ?? {}, { blur: N, focused: pe, isFocusTarget: me, moveFocus: P, setFocused: F } = gr(t, oe, de, fe ?? (() => !1), o), { labelDayButton: he, labelGridcell: ge, labelGrid: _e, labelMonthDropdown: ve, labelNav: ye, labelPrevious: be, labelNext: xe, labelWeekday: Se, labelWeekNumber: Ce, labelWeekNumberHeader: we, labelYearDropdown: Te } = a, Ee = m(() => Wn(o, t.ISOWeek, t.broadcastCalendar, t.today), [
		o,
		t.ISOWeek,
		t.broadcastCalendar,
		t.today
	]), De = f !== void 0 || v !== void 0, Oe = u(() => {
		O && (A(O), w?.(O));
	}, [
		O,
		A,
		w
	]), ke = u(() => {
		k && (A(k), C?.(k));
	}, [
		A,
		k,
		C
	]), Ae = u((e, t) => (n) => {
		n.preventDefault(), n.stopPropagation(), F(e), !t.disabled && (j?.(e.date, t, n), v?.(e.date, t, n));
	}, [
		j,
		v,
		F
	]), je = u((e, t) => (n) => {
		F(e), y?.(e.date, t, n);
	}, [y, F]), Me = u((e, t) => (n) => {
		N(), _?.(e.date, t, n);
	}, [N, _]), Ne = u((e, n) => (r) => {
		let i = {
			ArrowLeft: [r.shiftKey ? "month" : "day", t.dir === "rtl" ? "after" : "before"],
			ArrowRight: [r.shiftKey ? "month" : "day", t.dir === "rtl" ? "before" : "after"],
			ArrowDown: [r.shiftKey ? "year" : "week", "after"],
			ArrowUp: [r.shiftKey ? "year" : "week", "before"],
			PageUp: [r.shiftKey ? "year" : "month", "before"],
			PageDown: [r.shiftKey ? "year" : "month", "after"],
			Home: ["startOfWeek", "before"],
			End: ["endOfWeek", "after"]
		};
		if (i[r.key]) {
			r.preventDefault(), r.stopPropagation();
			let [e, t] = i[r.key];
			P(e, t);
		}
		b?.(e.date, n, r);
	}, [
		P,
		b,
		t.dir
	]), Pe = u((e, t) => (n) => {
		x?.(e.date, t, n);
	}, [x]), Fe = u((e, t) => (n) => {
		S?.(e.date, t, n);
	}, [S]), Ie = u((e, t) => (n) => {
		let r = Number(n.target.value), i = o.setMonth(o.startOfMonth(e), r);
		A(o.addMonths(i, -t));
	}, [o, A]), Le = u((e, t) => (n) => {
		let r = Number(n.target.value), i = o.setYear(o.startOfMonth(e), r);
		A(o.addMonths(i, -t));
	}, [o, A]), { className: Re, style: ze } = m(() => ({
		className: [l[G.Root], t.className].filter(Boolean).join(" "),
		style: {
			...E?.[G.Root],
			...t.style
		}
	}), [
		l,
		t.className,
		t.style,
		E
	]), I = _n(t), Be = (e) => {
		let t = E?.[G.Dropdown], n = E?.[e];
		if (!(!t && !n)) return {
			...t,
			...n
		};
	}, L = h(null);
	er(L, !!t.animate, {
		classNames: l,
		months: ce,
		focused: pe,
		dateLib: o
	});
	let Ve = {
		dayPickerProps: t,
		selected: M,
		select: j,
		isSelected: fe,
		months: ce,
		nextMonth: k,
		previousMonth: O,
		goToMonth: A,
		getModifiers: de,
		components: r,
		classNames: l,
		styles: E,
		labels: a,
		formatters: i
	};
	return c.createElement(Lt.Provider, { value: Ve }, c.createElement(r.Root, {
		rootRef: t.animate ? L : void 0,
		className: Re,
		style: ze,
		dir: t.dir,
		id: t.id,
		lang: t.lang ?? s.code,
		nonce: t.nonce,
		title: t.title,
		role: t.role,
		"aria-label": t["aria-label"],
		"aria-labelledby": t["aria-labelledby"],
		...I
	}, c.createElement(r.Months, {
		className: l[G.Months],
		style: E?.[G.Months]
	}, !t.hideNavigation && !p && c.createElement(r.Nav, {
		"data-animated-nav": t.animate ? "true" : void 0,
		className: l[G.Nav],
		style: E?.[G.Nav],
		"aria-label": ye(),
		onPreviousClick: Oe,
		onNextClick: ke,
		previousMonth: O,
		nextMonth: k
	}), ce.map((e, n) => {
		let a = t.reverseMonths ? ce.length - 1 - n : n;
		return c.createElement(r.Month, {
			"data-animated-month": t.animate ? "true" : void 0,
			className: l[G.Month],
			style: E?.[G.Month],
			key: n,
			displayIndex: n,
			calendarMonth: e
		}, p === "around" && !t.hideNavigation && n === 0 && c.createElement(r.PreviousMonthButton, {
			type: "button",
			className: l[G.PreviousMonthButton],
			style: E?.[G.PreviousMonthButton],
			tabIndex: O ? void 0 : -1,
			"aria-disabled": !O || void 0,
			"aria-label": be(O),
			onClick: Oe,
			"data-animated-button": t.animate ? "true" : void 0
		}, c.createElement(r.Chevron, {
			disabled: !O || void 0,
			className: l[G.Chevron],
			style: E?.[G.Chevron],
			orientation: t.dir === "rtl" ? "right" : "left"
		})), c.createElement(r.MonthCaption, {
			"data-animated-caption": t.animate ? "true" : void 0,
			className: l[G.MonthCaption],
			style: E?.[G.MonthCaption],
			calendarMonth: e,
			displayIndex: n
		}, d?.startsWith("dropdown") ? c.createElement(r.DropdownNav, {
			className: l[G.Dropdowns],
			style: E?.[G.Dropdowns]
		}, (() => {
			let n = d === "dropdown" || d === "dropdown-months" ? c.createElement(r.MonthsDropdown, {
				key: "month",
				className: l[G.MonthsDropdown],
				"aria-label": ve(),
				disabled: !!t.disableNavigation,
				onChange: Ie(e.date, a),
				options: Hn(e.date, le, ue, i, o),
				style: Be(G.MonthsDropdown),
				value: o.getMonth(e.date)
			}) : c.createElement("span", { key: "month" }, ne(e.date, o)), s = d === "dropdown" || d === "dropdown-years" ? c.createElement(r.YearsDropdown, {
				key: "year",
				className: l[G.YearsDropdown],
				"aria-label": Te(o.options),
				disabled: !!t.disableNavigation,
				onChange: Le(e.date, a),
				options: Gn(le, ue, i, o, !!t.reverseYears),
				style: Be(G.YearsDropdown),
				value: o.getYear(e.date)
			}) : c.createElement("span", { key: "year" }, ae(e.date, o));
			return o.getMonthYearOrder() === "year-first" ? [s, n] : [n, s];
		})(), c.createElement("span", {
			role: "status",
			"aria-live": "polite",
			style: {
				border: 0,
				clip: "rect(0 0 0 0)",
				height: "1px",
				margin: "-1px",
				overflow: "hidden",
				padding: 0,
				position: "absolute",
				width: "1px",
				whiteSpace: "nowrap",
				wordWrap: "normal"
			}
		}, ee(e.date, o.options, o))) : c.createElement(r.CaptionLabel, {
			className: l[G.CaptionLabel],
			style: E?.[G.CaptionLabel],
			role: "status",
			"aria-live": "polite"
		}, ee(e.date, o.options, o))), p === "around" && !t.hideNavigation && n === g - 1 && c.createElement(r.NextMonthButton, {
			type: "button",
			className: l[G.NextMonthButton],
			style: E?.[G.NextMonthButton],
			tabIndex: k ? void 0 : -1,
			"aria-disabled": !k || void 0,
			"aria-label": xe(k),
			onClick: ke,
			"data-animated-button": t.animate ? "true" : void 0
		}, c.createElement(r.Chevron, {
			disabled: !k || void 0,
			className: l[G.Chevron],
			style: E?.[G.Chevron],
			orientation: t.dir === "rtl" ? "left" : "right"
		})), n === g - 1 && p === "after" && !t.hideNavigation && c.createElement(r.Nav, {
			"data-animated-nav": t.animate ? "true" : void 0,
			className: l[G.Nav],
			style: E?.[G.Nav],
			"aria-label": ye(),
			onPreviousClick: Oe,
			onNextClick: ke,
			previousMonth: O,
			nextMonth: k
		}), c.createElement(r.MonthGrid, {
			role: "grid",
			"aria-multiselectable": f === "multiple" || f === "range",
			"aria-label": _e(e.date, o.options, o) || void 0,
			className: l[G.MonthGrid],
			style: E?.[G.MonthGrid]
		}, !t.hideWeekdays && c.createElement(r.Weekdays, {
			"data-animated-weekdays": t.animate ? "true" : void 0,
			className: l[G.Weekdays],
			style: E?.[G.Weekdays]
		}, T && c.createElement(r.WeekNumberHeader, {
			"aria-label": we(o.options),
			className: l[G.WeekNumberHeader],
			style: E?.[G.WeekNumberHeader],
			scope: "col"
		}, D()), Ee.map((e) => c.createElement(r.Weekday, {
			"aria-label": Se(e, o.options, o),
			className: l[G.Weekday],
			key: String(e),
			style: E?.[G.Weekday],
			scope: "col"
		}, ie(e, o.options, o)))), c.createElement(r.Weeks, {
			"data-animated-weeks": t.animate ? "true" : void 0,
			className: l[G.Weeks],
			style: E?.[G.Weeks]
		}, e.weeks.map((e) => c.createElement(r.Week, {
			className: l[G.Week],
			key: e.weekNumber,
			style: E?.[G.Week],
			week: e
		}, T && c.createElement(r.WeekNumber, {
			week: e,
			style: E?.[G.WeekNumber],
			"aria-label": Ce(e.weekNumber, { locale: s }),
			className: l[G.WeekNumber],
			scope: "row",
			role: "rowheader"
		}, re(e.weekNumber, o)), e.days.map((e) => {
			let { date: n } = e, i = de(e);
			if (i[K.focused] = !i.hidden && !!pe?.isEqualTo(e), i[q.selected] = fe?.(n) || i.selected, ln(M)) {
				let { from: e, to: t } = M;
				i[q.range_start] = !!(e && t && o.isSameDay(n, e)), i[q.range_end] = !!(e && t && o.isSameDay(n, t)), i[q.range_middle] = Y(M, n, !0, o);
			}
			let a = Un(i, E, t.modifiersStyles), s = hn(i, l, t.modifiersClassNames), u = !De && !i.hidden ? ge(n, i, o.options, o) : void 0;
			return c.createElement(r.Day, {
				key: `${e.isoDate}_${e.displayMonthId}`,
				day: e,
				modifiers: i,
				className: s.join(" "),
				style: a,
				role: "gridcell",
				"aria-selected": i.selected || void 0,
				"aria-label": u,
				"data-day": e.isoDate,
				"data-month": e.outside ? e.dateMonthId : void 0,
				"data-selected": i.selected || void 0,
				"data-disabled": i.disabled || void 0,
				"data-hidden": i.hidden || void 0,
				"data-outside": e.outside || void 0,
				"data-focused": i.focused || void 0,
				"data-today": i.today || void 0
			}, !i.hidden && De ? c.createElement(r.DayButton, {
				className: l[G.DayButton],
				style: E?.[G.DayButton],
				type: "button",
				day: e,
				modifiers: i,
				disabled: !i.focused && i.disabled || void 0,
				"aria-disabled": i.focused && i.disabled || void 0,
				tabIndex: me(e) ? 0 : -1,
				"aria-label": he(n, i, o.options, o),
				onClick: Ae(e, i),
				onBlur: Me(e, i),
				onFocus: je(e, i),
				onKeyDown: Ne(e, i),
				onMouseEnter: Pe(e, i),
				onMouseLeave: Fe(e, i)
			}, te(n, o.options, o)) : !i.hidden && te(e.date, o.options, o));
		}))))));
	})), t.footer && c.createElement(r.Footer, {
		className: l[G.Footer],
		style: E?.[G.Footer],
		role: "status",
		"aria-live": "polite"
	}, t.footer)));
}
//#endregion
//#region src/foundations/calendar/calendar.tsx
function kr({ className: e, classNames: n, showOutsideDays: s = !0, captionLayout: c = "label", buttonVariant: l = "ghost", formatters: u, components: d, ...f }) {
	return /* @__PURE__ */ _(Or, {
		showOutsideDays: s,
		className: t("bg-background group/calendar p-3 [--cell-size:2rem] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent", String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`, String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`, e),
		captionLayout: c,
		formatters: {
			formatMonthDropdown: (e) => e.toLocaleString("default", { month: "short" }),
			...u
		},
		classNames: {
			root: "w-fit",
			months: "relative flex flex-col gap-4 md:flex-row",
			month: "flex w-full flex-col gap-4",
			nav: "absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1",
			button_previous: t(r({ variant: l }), "h-(--cell-size) w-(--cell-size) select-none p-0 aria-disabled:opacity-50"),
			button_next: t(r({ variant: l }), "h-(--cell-size) w-(--cell-size) select-none p-0 aria-disabled:opacity-50"),
			month_caption: "flex h-(--cell-size) w-full items-center justify-center px-(--cell-size)",
			dropdowns: "flex h-(--cell-size) w-full items-center justify-center gap-1.5 text-sm font-medium",
			dropdown_root: "has-focus:border-ring border-input shadow-xs has-focus:ring-ring/50 has-focus:ring-[3px] relative rounded-md border",
			dropdown: "bg-popover absolute inset-0 opacity-0",
			caption_label: t("select-none font-medium", c === "label" ? "text-sm" : "[&>svg]:text-muted-foreground flex h-8 items-center gap-1 rounded-md pl-2 pr-1 text-sm [&>svg]:size-3.5"),
			month_grid: "w-full border-collapse",
			weekdays: "flex",
			weekday: "text-muted-foreground flex-1 select-none rounded-md text-[0.8rem] font-normal",
			week: "mt-2 flex w-full",
			week_number_header: "w-[--cell-size] select-none",
			week_number: "text-muted-foreground select-none text-[0.8rem]",
			day: "group/day relative aspect-square h-full w-full select-none p-0 text-center [&:first-child[data-selected=true]_button]:rounded-l-md [&:last-child[data-selected=true]_button]:rounded-r-md",
			range_start: "bg-accent rounded-l-md",
			range_middle: "rounded-none",
			range_end: "bg-accent rounded-r-md",
			today: "bg-accent text-accent-foreground rounded-md data-[selected=true]:rounded-none",
			outside: "[&:not([data-today])]:text-muted-foreground aria-selected:text-muted-foreground",
			disabled: "text-muted-foreground opacity-50",
			hidden: "invisible",
			...n
		},
		components: {
			Root: ({ className: e, rootRef: n, ...r }) => /* @__PURE__ */ _("div", {
				"data-slot": "calendar",
				ref: n,
				className: t(e),
				...r
			}),
			Chevron: ({ className: e, orientation: n, ...r }) => _(n === "left" ? a : n === "right" ? o : i, {
				className: t("size-4", e),
				...r
			}),
			DayButton: Ar,
			WeekNumber: ({ children: e, ...t }) => /* @__PURE__ */ _("td", {
				...t,
				children: /* @__PURE__ */ _("div", {
					className: "flex size-(--cell-size) items-center justify-center text-center",
					children: e
				})
			}),
			...d
		},
		...f
	});
}
function Ar({ className: e, day: r, modifiers: i, ...a }) {
	let o = s.useRef(null);
	return s.useEffect(() => {
		i.focused && o.current?.focus();
	}, [i.focused]), /* @__PURE__ */ _(n, {
		ref: o,
		variant: "ghost",
		size: "icon",
		"data-day": r.date.toLocaleDateString(),
		"data-selected-single": i.selected && !i.range_start && !i.range_end && !i.range_middle,
		"data-range-start": i.range_start,
		"data-range-end": i.range_end,
		"data-range-middle": i.range_middle,
		className: t("data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground data-[range-middle=true]:bg-accent data-[range-middle=true]:text-accent-foreground data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-ring/50 flex aspect-square h-auto w-full min-w-(--cell-size) flex-col gap-1 font-normal leading-none data-[range-end=true]:rounded-md data-[range-middle=true]:rounded-none data-[range-start=true]:rounded-md group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:ring-[3px] [&>span]:text-xs [&>span]:opacity-70", e),
		...a
	});
}
//#endregion
export { O as a, k as i, Ar as n, ce as o, pt as r, se as s, kr as t };

//# sourceMappingURL=calendar-BLyd2Htq.js.map